<mat-checkbox
  [checked]="selectedState.all"
  [indeterminate]="selectedState.some"
  (change)="onCheckboxChanged($event)"
></mat-checkbox>
